import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormAdmin from '../../forms/FormAdmin.jsx';

const PageAdmin = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      if (_id === 'self') {
        req({ url: '/api/core/users/self' });
      } else {
        req({ url: `/api/core/users/admins/${_id}` });
      }
    }
  }, [_id]);

  const breadcrumb = _id === 'self' ? [] : [
    { to: '../', children: 'Admins' },
  ];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Admin</Header>
      <FormAdmin />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormAdmin
            admin={doc}
          />
        </>
      )}
    </PageHttp>
  );
};

export default PageAdmin;
